import { render } from "./OfModal.vue?vue&type=template&id=6c964eb5"
import script from "./OfModal.vue?vue&type=script&lang=js"
export * from "./OfModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\anda\\Documents\\onlinefundraising\\of_spa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__